<template>
  <div class="learning-module-guide">
    <ym-popup class="learning-module-guide-popup"
              v-model="visible"
              get-container="body"
              position="bottom"
              :close-on-click-overlay="false"
    >
      <div class="learning-module-guide-container"
           :style="style"
      >
        <div class="learning-module-guide-info">
        <span class="">
          已购买，正在学习的课<br/>
          程都可以在这里找到哦！
        </span>
          <ym-button class="btn"
                     type="primary"
                     size="small"
                     @click="handleClick"
          >我知道了</ym-button>
        </div>
        <img class="learning-module-guide-leading-img"
             :src="require('@/assets/img/learning/leading.png')"
        />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup, Button } from '@ymba/ym-ui';
  import {
    getLearningModuleGuideStorageName,
    getFromStorage,
    setToStorage,
    isWeiXinBrowser,
    isIOS,
    isMiniWebView,
  } from '@/utils';

  export default {
    name: 'LearningModuleGuidePopup',
    components: {
      'ym-popup': Popup,
      'ym-button': Button,
    },
    data() {
      return {
        visible: false,
        isMiniWebView: isMiniWebView(),
        style: {},
      };
    },
    methods: {
      init() {
        const storageName = getLearningModuleGuideStorageName();
        const value = getFromStorage(storageName);
        if (value) return;
        const { name } = this.$route;
        const pageMap = [
          'Home',
          'Audio',
          'Course',
          'Mine',
        ];
        this.visible = !isMiniWebView && Boolean(pageMap.indexOf(name) > -1);
      },
      handleClick() {
        const storageName = getLearningModuleGuideStorageName();
        setToStorage(storageName, 1);
        this.visible = false;
      },
    },
    mounted() {
      this.$nextTick(() => {
        const isFullScreen = window && window.screen.height >= 812 && window.devicePixelRatio >= 2;
        const fullScreenBar = isFullScreen && isWeiXinBrowser() && isIOS() ? 60 : 0;
        const height = fullScreenBar / 74.7;
        this.style = { 'padding-bottom': `${height}rem` };
        this.init();
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .learning-module-guide {
    &-popup {
      background: none;
    }
    &-container {
      box-sizing: border-box;
      padding-right: @size-medium;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
      color: @color-white;
      background: none;
    }
    &-info {
      margin-bottom: @size-base;
      display: flex;
      align-items: flex-end;
      color: @color-white;
      font-size: @font-size-medium;
      line-height: 1.5;
      .btn {
        margin-left: @size-extra-small;
      }
    }
    &-leading-img {
      margin-right: 136px;
      display: block;
      width: 100px;
      height: 310px;
    }
  }

</style>
